export const highlightTerm = (text, term) => {
    if (!term)
        return text;
    const regex = new RegExp(`(${term})`, 'gi');
    return text.replace(regex, '<mark>$1</mark>');
};
//# sourceMappingURL=HighlightTerm.js.map